import styles from './sideSlider.module.css'

const sideSliderStyles = {
  slidercontainer: `relative w-full h-full overflow-hidden bg-themeColor flex justify-center items-center ${styles.slider_wrpr}`,
  slidercontent: `w-full h-full flex justify-center items-center`,
  sliderimage: `w-[inherit] h-[inherit] object-cover`,
  arrowscontainer: `absolute bottom-3 flex space-x-4 z-10 xl:right-28
                    lg:right-20
                    md:right-16`,
  arrow: `opacity-100
          disabled:opacity-50 
  `,
  arrowImage: `transition-opacity duration-300`,
};

export { sideSliderStyles };
